export const ExtraLightFontWeight = 200;
export const LightFontWeight = 300;
export const RegularFontWeight = 400;
export const MediumFontWeight = 600;
export const StrongFontWeight = 700;
export const DefaultFontName = `'Inter', sans-serif`;
